/* Behaviour for sections/ASRJ-burger-menu-mobile-FRONT.liquid (moved out of the inline <script>; loaded with defer). */
// --- SEARCH UI TOGGLE LOGIC ---
function focusMenuSearch() {
  const menuItems = document.querySelector('.menu-items');
  const bottomMenu = document.querySelector('.bottom-menu');
  const closeBtn = document.querySelector('.menu-search-close-btn');
  const searchResults = document.querySelector('.mobile-search-container .header__search__results');
  
  if(menuItems) menuItems.style.display = 'none';
  if(bottomMenu) bottomMenu.style.display = 'none';
  if(closeBtn) closeBtn.style.display = 'flex';
  if(searchResults) searchResults.style.display = 'block';
}

function closeMenuSearch(e) {
  if(e) e.preventDefault();
  
  const input = document.querySelector('.mobile-search-container [data-predictive-search-input]');
  if(input) {
    input.value = '';
    // Trigger input event to clear native search results state
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  const menuItems = document.querySelector('.menu-items');
  const bottomMenu = document.querySelector('.bottom-menu');
  const closeBtn = document.querySelector('.menu-search-close-btn');
  const searchResults = document.querySelector('.mobile-search-container .header__search__results');
  const outer = document.querySelector('.mobile-search-container [data-popdown-outer]');

  if(menuItems) menuItems.style.display = '';
  if(bottomMenu) bottomMenu.style.display = '';
  if(closeBtn) closeBtn.style.display = 'none';
  if(searchResults) searchResults.style.display = 'none';
  if(outer) outer.classList.remove('dirty', 'is-visible');
}

// --- VIEW ALL REDIRECT ---
document.addEventListener('mousedown', function(e) {
  const viewAllBtn = e.target.closest('.js-view-all-btn');
  if (!viewAllBtn) return;

  const liveInput = document.querySelector('.mobile-search-container .custom-minimal-search-input');
  let queryTerm = liveInput ? liveInput.value : "";

  if (queryTerm.trim() !== "") {
    const encodedQuery = encodeURIComponent(queryTerm);
    window.location.href = `/search?type=product&q=${encodedQuery}`;
  } else {
    window.location.href = `/search?type=product`;
  }
});

// --- MENU CLOSE LOGIC ---
function syncAsrjMenuOpenClass() {
  var mobileMenu = document.getElementById('mobile-menu');
  var open = !!(mobileMenu && mobileMenu.classList.contains('open'));
  document.documentElement.classList.toggle('asrj-menu-open', open);
}

function closeAsrjDrawer() {
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  
  // Reset search layout on Drawer close
  closeMenuSearch();
  
  if (mobileMenu) mobileMenu.classList.remove('open');
  if (mobileMenuToggle) mobileMenuToggle.classList.remove('open');
  document.body.classList.remove('no-scroll');
  syncAsrjMenuOpenClass();
  
  document.querySelectorAll('.has-submenu').forEach(function(item) {
    item.classList.remove('open');
    const toggleBtn = item.querySelector('.submenu-toggle');
    if (toggleBtn) toggleBtn.innerText = "+";
    
    const submenu = item.querySelector('.submenu');
    if (submenu) {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
      setTimeout(() => {
        submenu.style.maxHeight = '0';
        submenu.style.paddingTop = '0';
        submenu.style.paddingBottom = '0';
      }, 10);
    }
  });
}

const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
if (mobileMenuToggle) {
  mobileMenuToggle.addEventListener('click', function() {
    this.classList.toggle('open');
    document.getElementById('mobile-menu').classList.toggle('open');
    document.body.classList.toggle('no-scroll');
    syncAsrjMenuOpenClass();

    // Reset search layout on toggle
    if (!this.classList.contains('open')) {
      closeMenuSearch();
    }
  });
}

// --- SUBMENU LOGIC ---
document.querySelectorAll('.has-submenu > a').forEach(function(toggle) {
  toggle.addEventListener('click', function(e) {
    e.preventDefault();
    const parent = this.parentElement;
    document.querySelectorAll('.has-submenu').forEach(function(item) {
      if (item !== parent) {
        item.classList.remove('open');
        const toggleBtn = item.querySelector('.submenu-toggle');
        if (toggleBtn) toggleBtn.innerText = "+";
        
        const submenu = item.querySelector('.submenu');
        if (submenu) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px'; 
          setTimeout(() => {
            submenu.style.maxHeight = '0';
            submenu.style.paddingTop = '0';
            submenu.style.paddingBottom = '0';
          }, 10);
        }
      }
    });
    parent.classList.toggle('open');
    const submenuToggle = parent.querySelector('.submenu-toggle');
    const submenu = parent.querySelector('.submenu');
    
    if (parent.classList.contains('open')) {
      if (submenuToggle) submenuToggle.innerText = "";
      if (submenu) {
        submenu.style.maxHeight = submenu.scrollHeight + 20 + 'px';
        submenu.style.paddingTop = '10px';
        submenu.style.paddingBottom = '10px';
      }
    } else {
      if (submenuToggle) submenuToggle.innerText = "+";
      if (submenu) {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        setTimeout(() => {
          submenu.style.maxHeight = '0';
          submenu.style.paddingTop = '0';
          submenu.style.paddingBottom = '0';
        }, 10);
      }
    }
  });
});

// CLOSE ON OUTSIDE CLICK
document.addEventListener('click', function(event) {
  const mobileMenu = document.getElementById('mobile-menu');
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  
  if (mobileMenu && toggleBtn) {
    var isClickInside = mobileMenu.contains(event.target) || toggleBtn.contains(event.target);
    if (!isClickInside) {
      closeAsrjDrawer();
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.submenu').forEach(function(submenu) {
    submenu.style.maxHeight = '0';
    submenu.style.paddingTop = '0';
    submenu.style.paddingBottom = '0';
  });
});
